<template>
    <div>
      <van-nav-bar
        title="总账单"
        left-text="返回"
        left-arrow
        @click-left="$router.push('/member/members')"
      />
      <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
        <div class="backgroud">
          <br>
          <van-row >
            <van-col span="8"> </van-col>
            <van-col span="8">
              <div class="capital-box1">
                <div class="capital-header">
                  <img src="../assets/images/timebao.png" alt="">
                  <h5>总账单</h5>
                </div>
                <br>
                <p>{{ cash }} 元</p>
              </div>
            </van-col>
            <van-col span="8"
              ><div class="capital-box">
                <router-link to="/member/detailed_log"
                  ><h5 style="color: #0D268D">账单 ></h5>
                  </router-link
                >
              </div></van-col
            >
          </van-row>
        </div>
        <br>
        
        <div class="capital-btn">
          <van-row>
            <van-col span="12">
            <van-button
              round
              type="danger"
              size="normal"
              class="members-button"
              style="height: 30px; background-color: #D02E27; border:1px solid #D02E27;width:100px"
              @click="goToRechargePage()"
              >充值</van-button
            >
            </van-col>
            <van-col span="12">
                <van-button
              round
              type="info"
              size="normal"
              class="members-button"
              style="height: 30px; background-color: #0D268D;border: #0D268D;;width:100px"
              @click="goToWithdrawPage()"
              >提现</van-button
            >
            </van-col>
          </van-row>
        </div>
      </van-pull-refresh>
    </div>
  </template>
  
  <script>
  export default {
    name: "Account",
    data() {
      return {
        isLoading: false,
        cash: 0,
      };
    },
    computed: {},
    methods: {
      isLogin() {
        let that = this;
        if (!that.$store.state.loginType) {
          that.$router.push("/login");
        }
      },
      mainMethod() {
        this.getUserinfo();
      },
      onRefresh() {
        this.mainMethod();
        this.isLoading = false;
      },
  
      getUserinfo() {
        let that = this;
        that
          .$http({
            url: "/",
            method: "post",
            data: {
              nozzle: "user",
              token: sessionStorage.getItem("token"),
            },
          })
          .then(function (res) {
            if (res.data.code == 1) {
              that.cash = res.data.data.cash;
            } else if (res.data.code == 0 || res.data.code == -1) {
              that.$message.error(res.data.msg);
            }
          });
      },
      goToRechargePage() {
      let that = this;
      if (that.trade_channel_status == 1) {
        that.getTradeChannel();
      } else {
        that.$router.push("/member/recharge");
      }
    },

    goToWithdrawPage() {
      let that = this;
      if (that.trade_channel_status == 1) {
        that.getTradeChannel();
      } else {
        that.$router.push("/member/withdrawal");
      }
    },

    },
    mounted() {
      this.getUserinfo();
    },
  };
  </script>
  
  <style scoped>
  .navstyles {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
  }
  
  .capital {
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }
  
  .capital h5 {
    margin: 0;
    font-size: 14px;
    font-weight: 300;
    color: #000000;
  }
  
  .capital p {
    margin: 0;
    color: #D02E27;
    font-size: 14px;
    font-weight: bold;
  }
  
  .capital-box {
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }

  .capital-box1 {
    height: 60px;
    display: flex;
    align-items: left;
    justify-content: center;
    flex-direction: column;
  }
  
  .capital-box h5 {
    margin: 0;
    font-size: 16px;
    font-weight: 300;
    color: #000000;
  }

  .capital-box1 h5 {
    margin: 0;
    font-size: 16px;
    font-weight: 300;
    color: #000000;
  }
  
  .capital-box p {
    margin: 0;
    color: #D02E27;
    font-size: 18px;
    font-weight: bold;
  }

  .capital-box1 p {
    margin: 0;
    color: #D02E27;
    font-size: 18px;
    font-weight: bold;
  }
  .capital-btn {
    margin-top: 10px;
    text-align: center;
  }
  .capital-header {
    margin-top: 5px;
    display: flex;
    align-items: center; /* Align items in the same line */
  }
  
  .capital-header img {
    width: 25px;  
    height: 25x; 
    margin-right: 5px; 
    margin-top: -2px;
  }
  
  .backgroud {
      margin:10px 10px 5px 10px !important;
      border:1px solid #e3e3e3!important;
      border-radius: 20px !important;
      overflow: hidden;
      height: 100px;
    }
  .button-in{
    background-color: #D02E27 !important;
    border: 1px solid #D02E27!important;
  }
  .button-out{
    background-color: #0D268D !important;
    border: 1px solid #0D268D!important;
  }
  </style>
  


// WEBPACK FOOTER //
// src/components/Account.vue